import React from "react"
import DeliveryOptionCompactSkeletonCard from "./DeliveryOptionCompactSkeletonCard.component"

const DeliveryOptionCompactSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col w-full">
      <div>
        <DeliveryOptionCompactSkeletonCard />
        <DeliveryOptionCompactSkeletonCard />
      </div>
    </div>
  )
}

export default DeliveryOptionCompactSkeleton
